import type { IncomingStudy } from '@/services/incomingStudies';

export interface StudyAssignmentEntry {
  serial: string;
  user_type: string;
}

/** Mirrors api-radiologox/models.NormalizeUserSerial */
export function normalizeUserSerial(serial: string): string {
  return serial.trim().toUpperCase();
}

/** Mirrors api-radiologox/models.NormalizeAssignmentUserType */
export function normalizeAssignmentUserType(userType: string): string {
  return userType.trim().toUpperCase();
}

/**
 * REFERRER web lane: study visible only with typed assignment (serial + REFERRER).
 * Same rule as study_visibility_filter.go → studyAssignedForUserLane.
 */
export function isStudyAssignedToReferrer(
  study: IncomingStudy,
  referrerSerial: string,
): boolean {
  const wantSerial = normalizeUserSerial(referrerSerial);
  if (!wantSerial) return false;

  const assigned = study.assigned;
  if (!assigned?.length) return false;

  return assigned.some(
    (entry) =>
      normalizeUserSerial(entry.serial) === wantSerial &&
      normalizeAssignmentUserType(entry.user_type) === 'REFERRER',
  );
}

/** Client-side guard: never surface studies without REFERRER typed assignment. */
export function filterStudiesForReferrer(
  studies: IncomingStudy[],
  referrerSerial: string,
): IncomingStudy[] {
  if (!normalizeUserSerial(referrerSerial)) return [];
  return studies.filter((study) => isStudyAssignedToReferrer(study, referrerSerial));
}
